import { render, staticRenderFns } from "./Organizations.vue?vue&type=template&id=3b5f6cda&scoped=true"
import script from "./Organizations.vue?vue&type=script&lang=js"
export * from "./Organizations.vue?vue&type=script&lang=js"
import style0 from "./Organizations.vue?vue&type=style&index=0&id=3b5f6cda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5f6cda",
  null
  
)

export default component.exports